import type { VendorUserDTO } from '@pms/shared';

/**
 * Vendor realm token keychain (TASK-144) — DELIBERATELY separate keys from the
 * staff `pms_*` keychain so a vendor token is never sent to a staff API and vice
 * versa. The vendor axios instance (vendorApi.ts) reads only these.
 */
const KEYS = {
  ACCESS: 'vendor_access_token',
  REFRESH: 'vendor_refresh_token',
  USER: 'vendor_user',
} as const;

export function getVendorToken(): string | null {
  return localStorage.getItem(KEYS.ACCESS);
}

export function getVendorRefreshToken(): string | null {
  return localStorage.getItem(KEYS.REFRESH);
}

export function setVendorTokens(accessToken: string, refreshToken: string): void {
  localStorage.setItem(KEYS.ACCESS, accessToken);
  localStorage.setItem(KEYS.REFRESH, refreshToken);
}

export function clearVendorSession(): void {
  localStorage.removeItem(KEYS.ACCESS);
  localStorage.removeItem(KEYS.REFRESH);
  localStorage.removeItem(KEYS.USER);
}

export function getVendorUser(): VendorUserDTO | null {
  const raw = localStorage.getItem(KEYS.USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as VendorUserDTO;
  } catch {
    return null;
  }
}

export function setVendorUser(user: VendorUserDTO): void {
  localStorage.setItem(KEYS.USER, JSON.stringify(user));
}

export function isVendorAuthenticated(): boolean {
  return getVendorToken() !== null;
}
